/** Site-wide defaults — must match absolute URLs in public/index.html for WhatsApp crawlers. */
export const SITE_ORIGIN =
    process.env.REACT_APP_SITE_URL || "https://cheppar.co.ke";

export const DEFAULT_OG = {
    title: "Build Bout — Karibu. Build. Ship. Nakuru.",
    description:
        "A co-working community of builders shipping together from rural Kenya. Hackathons, accountability, and shipped demos.",
    image: `${SITE_ORIGIN}/og-image.jpg`,
    imageWidth: 1200,
    imageHeight: 630,
};

/** Per-route Open Graph (browser + future prerender; WhatsApp uses index.html unless cached per URL). */
export const ROUTE_OG = {
    "/": DEFAULT_OG,
    "/hackathon": {
        title: "Agentic Hack — Build Bout · 10 Oct 2026",
        description:
            "Free hackathon in Nakuru. Build with agents and robots. Register on Luma.",
        image: `${SITE_ORIGIN}/og-image.jpg`,
        imageWidth: 1200,
        imageHeight: 630,
    },
    "/merch/cups": {
        title: "Party Kenya — Build Bout Merch",
        description:
            "Branded party cups in five colours. EPL team stickers from Nakuru. Pay with M-Pesa.",
        image: `${SITE_ORIGIN}/og-merch.jpg`,
        imageWidth: 1200,
        imageHeight: 630,
    },
    "/events": {
        title: "Build Bout Events",
        description: "Hackathons and community sessions in Nakuru, Kenya.",
        image: `${SITE_ORIGIN}/og-image.jpg`,
        imageWidth: 1200,
        imageHeight: 630,
    },
    "/environment": {
        title: "Build Bout Environment",
        description: "Our space and community in Nakuru.",
        image: `${SITE_ORIGIN}/og-image.jpg`,
        imageWidth: 1200,
        imageHeight: 630,
    },
};

export function getOgForPath(pathname) {
    const path = pathname?.replace(/\/$/, "") || "/";
    if (ROUTE_OG[path]) return ROUTE_OG[path];
    if (path.startsWith("/merch")) return ROUTE_OG["/merch/cups"];
    return DEFAULT_OG;
}
